import React, { useEffect, useState, useRef, useContext } from "react";
import { getAllFolder, deleteFolder } from "../api/folderapi";
import { useNavigate } from "react-router-dom";
import { getFileIcon } from "../utils/Icon";
import FileView from "../Component/FIleView";
import DeleteView from "../Component/DeleteView";
import { CiMenuKebab, CiSettings } from "react-icons/ci";
import { BsDownload } from "react-icons/bs";
import { AiOutlineDelete } from "react-icons/ai";
import { AnimatePresence } from "framer-motion";
import { toast } from "react-toastify";
import { FileContext } from "../context/FileContext";
import FileContainer from "../Component/FileContainer";
import Loader from "../Component/Loader";
import { CiSearch } from "react-icons/ci";

const Photos = () => {
  const {
    files,
    setFiles,
    viewType,
    setViewType,
    search,
    setSearch,
    sortOption,
    setSortOption,
  } = useContext(FileContext);

  const [images, setImages] = useState([]);
  const [selectedFile, setSelectedFile] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [selectedFolderForDelete, setSelectedFolderForDelete] = useState(null);
  const [menuOpen, setMenuOpen] = useState(null);
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const [settingOpen, setSettingOpen] = useState(false);
  const [selectedFolder, setSelectedFolder] = useState(null);
  const navigate = useNavigate();
  const menuRef = useRef(null);

  useEffect(() => {
    setIsLoading(true);
    getAllFolder()
      .then((res) => {
        const imageFiles = res.data.filter(
          (item) => item.mimeType && item.mimeType.includes("image")
        );
        setImages(imageFiles);
      })
      .catch((err) => console.log(err))
      .finally(() => setIsLoading(false));
  }, []);

  const handleItemClick = (item) => {
    if (item.type === "folder") {
      navigate("/folder/" + item._id);
    } else {
      setSelectedFile(item);
    }
  };

  const handleDownload = (url) => {
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", "");
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const handleDeleteClick = (file) => {
    setSelectedFolderForDelete(file);
    setIsPopupOpen(true);
  };

  const handleDeleteConfirm = async () => {
    try {
      if (selectedFolderForDelete) {
        await deleteFolder(selectedFolderForDelete._id);
        const updatedImages = images.filter(
          (img) => img._id !== selectedFolderForDelete._id
        );
        setImages(updatedImages);
        const updatedFiles = files.filter(
          (file) => file._id !== selectedFolderForDelete._id
        );
        setFiles(updatedFiles);
        toast.success("File deleted successfully");
        setIsPopupOpen(false);
        setSelectedFolderForDelete(null);
        setMenuOpen(null);
      }
    } catch (error) {
      toast.error("Error deleting file");
    }
  };

  const handleDeleteCancel = () => {
    setIsPopupOpen(false);
    setSelectedFolderForDelete(null);
  };

  const openFolderSettings = (folder) => {
    setSelectedFolder(folder);
    setSettingOpen(true);
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (menuRef.current && !menuRef.current.contains(event.target)) {
        setMenuOpen(null);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  // Filter based on search
  const filteredImages = images.filter((img) =>
    img.name.toLowerCase().includes(search.toLowerCase())
  );

  return (
    <div className=" mt-[10%] md:mt-[4%]">
        <div className="mt-5"></div>
      <h2 className="text-2xl font-semibold text-black ">Photos</h2>

      {isLoading ? (
        <Loader />
      ) : (
       <div className="grid grid-cols-2 gap-5 mt-5 md:grid-cols-4 lg:grid-cols-5">
  {filteredImages.map((file, index) => {
    const icon = getFileIcon(file.name, file.url);
    return (
      <FileContainer
        key={index}
        className="relative flex flex-col items-center border border-gray-300 rounded-md shadow w-30 h-30 md:w-44 md:h-40 mt-5"
      >
        {/* Menu icon */}
        <span className="absolute right-0 p-2">
          <CiMenuKebab
            onClick={() =>
              setMenuOpen(menuOpen === index ? null : index)
            }
          />
        </span>

        {/* Dropdown menu */}
        <AnimatePresence>
          {menuOpen === index && (
            <div
              className="absolute right-0 z-50 w-32 bg-white border border-gray-200 rounded-md shadow-lg top-6 md:w-40"
              ref={menuRef}
            >
              <ul className="flex flex-col p-2">
                <li>
                  <button
                    onClick={() => handleDownload(file.url)}
                    className="flex items-center w-full gap-2 px-3 py-2 text-gray-700 rounded-md hover:bg-gray-100"
                  >
                    <BsDownload className="w-4 h-4 text-blue-500" />
                    <span className="text-sm font-medium">Download</span>
                  </button>
                </li>
                <li>
                  <button
                    onClick={() => openFolderSettings(file)}
                    className="flex items-center w-full gap-2 px-3 py-2 text-gray-700 rounded-md hover:bg-gray-100"
                  >
                    <CiSettings className="w-4 h-4 text-gray-500" />
                    <span className="text-sm font-medium">Settings</span>
                  </button>
                </li>
                <li>
                  <button
                    onClick={() => handleDeleteClick(file)}
                    className="flex items-center w-full gap-2 px-3 py-2 text-red-600 rounded-md hover:bg-red-100"
                  >
                    <AiOutlineDelete className="w-4 h-4 text-red-500" />
                    <span className="text-sm font-medium">Delete</span>
                  </button>
                </li>
              </ul>
            </div>
          )}
        </AnimatePresence>

        {/* Image preview */}
        <div
          onClick={() => handleItemClick(file)}
          className="flex items-center justify-center w-full h-32 object-contain p-2"
        >
          {typeof icon === "string" ? (
            <img
              src={icon}
              alt={file.name}
              className="max-w-full max-h-full object-contain"
            />
          ) : (
            icon
          )}
        </div>

        {/* File name */}
        <div className="p-2 text-sm font-medium text-center text-gray-700 truncate">
          {file.name.length > 10 ? file.name.slice(0, 10) + "..." : file.name}
        </div>
      </FileContainer>
    );
  })}
</div>

      )}

      {/* Delete Confirmation Modal */}
      {isPopupOpen && (
        <DeleteView
          handleDeleteCancel={handleDeleteCancel}
          handleDeleteConfirm={handleDeleteConfirm}
        />
      )}

      {/* File Preview Modal */}
      {selectedFile && (
        <FileView
          selectedFile={selectedFile}
          setSelectedFile={setSelectedFile}
          handleDownload={handleDownload}
        />
      )}
    </div>
  );
};

export default Photos;
